import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TabNavigationService {
    private mainTabSubject = new BehaviorSubject<string>('introduction');
    private subTabSubject = new BehaviorSubject<{
        mainTab: string;
        subTab: string;
    } | null>(null);

    mainTab$ = this.mainTabSubject.asObservable();
    subTab$ = this.subTabSubject.asObservable();

    navigateToTab(mainTab: string, subTab?: string) {
        this.mainTabSubject.next(mainTab);
        if (subTab) {
            this.subTabSubject.next({ mainTab, subTab });
        } else {
            // Clear sub-tab state when navigating to main tab only
            this.subTabSubject.next(null);
        }
    }

    resetToDefault() {
        this.mainTabSubject.next('introduction');
        this.subTabSubject.next(null);
    }
}
